/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2020-02-12 11:57:39
 * @LastEditors: wdm
 * @LastEditTime: 2020-03-11 13:44:08
 */
/**
 * @ Author: Your name
 * @ Create Time: 2019-06-14 20:45:34
 * @ Modified by: Your name
 * @ Modified time: 2019-07-20 15:46:05
 * @ Description: 自定义表单校验规则
 */
// eslint-disable-next-line import/prefer-default-export
export function correctPhone(rule, value, callback) {
  const valid = /^1[3456789]\d{9}$/.test(value)
  if (!valid) {
    callback(new Error('请输入正确的手机号格式'))
  } else {
    callback()
  }
}
export function validatorUrls(rule, value, callback) {
  const valid = /(http|ftp|https):\/\/[\w]/.test(value)
  if (!valid) {
    callback(new Error('请输入正确的API地址格式'))
  } else {
    callback()
  }
}
export function onlyNumberLetter(rule, value, callback) {
  // const valid = /^[A-Za-z0-9]+$/.test(value)
  const valid = /^[\da-zA-Z!@#$%^&*]*$/.test(value)

  if (!valid) {
    callback(new Error('请输入数字或字母'))
  } else {
    callback()
  }
}
export function validatePass(rule, value, callback) {
  if (value.length < 5) {
    callback(new Error('密码不能小于5位'))
  } else {
    callback()
  }
}

export function validatePWD(rule, value, callback) {
  const validLen = value.length < 5 || value.length > 18
  // const valid = /^[A-Za-z0-9]+$/.test(value)
  const valid = /^[\da-zA-Z!@#$%^&*]*$/.test(value)

  if (!value || validLen) {
    callback(new Error('请输入5-18位数的密码'))
  } else if (!valid) {
    callback(new Error('请输入数字或字母'))
  } else {
    callback()
  }
}
